module.exports = __webpack_public_path__ + "static/media/LivingRoomDesigner.dab89756.jpg";